"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdventureFailedEventArgs = void 0;
const EventType_1 = require("../EventType");
class AdventureFailedEventArgs {
    constructor(adventureId) {
        this.adventureId = adventureId;
        this.__type = EventType_1.EventType.AdventureFailed;
        this.__typeName = "AdventureFailed";
    }
}
exports.AdventureFailedEventArgs = AdventureFailedEventArgs;
